import Cookies from 'js-cookie'

const COOKIE_NAME = 'hide_banners'

class Banner {
  /**
   * Create new closable banner
   * @param {Object} options
   * @param {HTMLElement} options.container
   */
  constructor ({ container }) {
    this.container = container
    this.closeButton = container.querySelector('.js-banner-close')
    this.id = container.dataset.id
  }

  init () {
    this.closeButton?.addEventListener('click', () => this.close())
  }

  close () {
    const hiddenBanners = new Set(Cookies.get(COOKIE_NAME)?.split(','))
    hiddenBanners.add(this.id)

    Cookies.set(COOKIE_NAME, [...hiddenBanners], {
      expires: 30,
      sameSite: 'strict'
    })

    this.container.remove()
  }
}

const bannerContainers = document.querySelectorAll('.js-banner')

for (const container of bannerContainers) {
  new Banner({ container }).init()
}
